// extracted by mini-css-extract-plugin
export default {"title":"ShareList_title__KD3GL"};